import React, { useState, useEffect } from 'react';

import DataTableMui from '../../../components/DataTableMui';
import { useGlobal } from '../../../contexts/Global/context';
import ButtonDownload from '../../../components/ButtonDownload';

import { buscarCartaReajuste } from '../../../services';

import { TableContainer } from '../../../styles/styles';

function CartaReajuste() {
    const [dataTable, setDataTable] = useState([]);
    const [loading, setLoading] = useState(false);
    const { dataActiveContract, contractsGroupsList } = useGlobal();

    const dataGroup = contractsGroupsList.find(
        ({ idGrupoContrato }) => idGrupoContrato.toString() === dataActiveContract.codGrupoEmpresa
    );

    useEffect(() => {
        (async () => {
            setLoading(true);
            const { data } = await buscarCartaReajuste(dataActiveContract.numContratoPrincipal);

            if (data) {
                const dataUrl = `data:application/pdf;base64,${data.base64}`;
                setDataTable([
                    {
                        grupo: dataGroup.grupoContrato,
                        nomeArquivo: 'Carta de reajuste',
                        download: <ButtonDownload tooltipIcon="Baixar Carta de Reajuste" file={dataUrl} />,
                    },
                ]);
            }
            setLoading(false);
        })();
    }, []);

    const columnsHead = [
        {
            key: 'grupo',
            selector: (row) => row.grupo || '-',
            name: 'Grupo de Contrato',
            sortable: true,
            direction: 'left',
            customStyles: () => ({ width: '33%', height: '60px' }),
        },
        {
            key: 'nomeArquivo',
            selector: (row) => row.nomeArquivo || '-',
            name: 'Nome do arquivo',
            sortable: true,
            direction: 'left',
            customStyles: () => ({ width: '33%', height: '60px' }),
        },
        {
            key: 'download',
            selector: (row) => row.download,
            name: '',
            sortable: false,
            direction: 'left',
            customStyles: () => ({ width: '33%', height: '60px' }),
        },
    ];

    return (
        <TableContainer>
            <DataTableMui
                clickableRow={false}
                data={dataTable}
                emptyMessage="Não encontramos carta de reajuste para o contrato desejado."
                loading={loading}
                columns={columnsHead}
                alreadySearched={!!dataTable}
                firstOrderBy="grupo"
            />
        </TableContainer>
    );
}

export default CartaReajuste;
